import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import NotFound from '../../../Images/notFound.png';
import { Paper, makeStyles, TableBody, TableRow, TableCell, CircularProgress, Switch, Button, Dialog, DialogTitle, DialogContent, Select, MenuItem, DialogActions } from '@material-ui/core';
import useTable from '../../useTable';
import CheckUserProvider from '../../../AllHooks/CheckUserProvider';
import { Helmet } from 'react-helmet';
import { getTodayAvailableSupplyOrderDocument } from '../../../Backend/firebase/supply-order';
import { parseDate } from '../../Models/CommonFunc';
import { useHistory } from 'react-router-dom';
import RefreshOrderFilter from './RefreshOrderFilter';
import db from '../../../Backend/firebase/firebase';
import CustomAlert from '../../CustomAlert';
import WholesalerDialog from './Popup/WholesalerDialog';


const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        width: '100%'
    },
    fixedHeight: {
        height: '100%',
    },
}));

const headCells = [
    { id: 'IsAvailable', label: 'Is Available', disableSorting: true },
    { id: 'ProductName', label: 'Product Name', disableSorting: true },
    { id: 'ProductQuantity', label: 'Quantity', disableSorting: true },
    { id: 'ProductScheme', label: 'Scheme', disableSorting: false },
    { id: 'MedicineType', label: 'Medicine Type', disableSorting: false },
    { id: 'SupplyOrderPostedDateTime', label: 'Date', disableSorting: false },
]

function SupplyPickupFlow() {
    const classes = useStyles();
    const history = useHistory();
    var batch = db.batch();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const [openNotify, setOpenNotify] = React.useState(false)
    const [notificationMessage, setNotificationMessage] = useState('')
    const [alertType, setAlertType] = useState('')
    const { userData } = CheckUserProvider();
    const [records, setRecords] = useState([]);
    const SalectedDate = parseDate(new Date());
    const [isLoading, setIsLoading] = useState(true);
    const { TblContainer, TblHead, TblPagination } = useTable(records, headCells);
    const [pendingUpdates, setPendingUpdates] = useState([]);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [selectedWholesaler, setSelectedWholesaler] = useState('');

    useEffect(async () => {
        var isLogin = localStorage.getItem(process.env.REACT_APP_EMPLOYER_ISLOGIN) || false;
        if (!isLogin || isLogin == "false") {
            history.push("/activity/Login");
        }
    }, [])

    useEffect(async () => {
        if (userData) {
            fetchRecord();
        }
    }, [userData]);

    const fetchRecord = async () => {
        setIsLoading(true);
        try {
            const getSupplyOrder = await getTodayAvailableSupplyOrderDocument();
            const todaysMedicine = getSupplyOrder.filter(x =>
                parseDate(x.SupplyOrderPostedDateTime).includes(SalectedDate)
            );
            setRecords(todaysMedicine);
            setIsLoading(false);
        } catch (error) {
            console.log("Error Occur in Get Order", error)
            setIsLoading(false);
        }
    }

    const handleToggle = async (item) => {
        const newAvailability = !item.IsAvailable;

        // Update the local records state
        const updatedRecords = records.map(record =>
            record._id === item._id ? { ...record, IsAvailable: newAvailability } : record
        );
        setRecords(updatedRecords);

        const updatedPendingUpdates = [...pendingUpdates];
        const existingUpdateIndex = updatedPendingUpdates.findIndex(update => update._id === item._id);

        if (existingUpdateIndex > -1) {
            updatedPendingUpdates[existingUpdateIndex].IsAvailable = newAvailability;
        } else {
            updatedPendingUpdates.push({ _id: item._id, IsAvailable: newAvailability });
        }
        setPendingUpdates(updatedPendingUpdates);
    };

    const handleProceedNext = async () => {
        if (pendingUpdates.length === 0) {
            setNotificationMessage('No updates to apply.');
            setOpenNotify(true);
            setAlertType('error');
            return;
        }
        setIsPopupOpen(true);
    }

    const handleSubmit = async () => {
        if (!selectedWholesaler) {
            setNotificationMessage('Please select a wholesaler.');
            setOpenNotify(true);
            setAlertType('error');
            return;
        }
        try {
            pendingUpdates.forEach(update => {
                const docRef = db.doc(`/SupplyOrder/${update._id}`);
                batch.update(docRef, {
                    IsAvailable: update.IsAvailable,
                    WholesalerId: selectedWholesaler
                });
            });

            batch.commit().then(() => {
                setNotificationMessage('Order Update successfully.')
                setOpenNotify(true)
                setAlertType('success')
                setIsPopupOpen(false);
                setPendingUpdates([]);
                fetchRecord();
            }).catch((error) => {
                console.error(error);
                setNotificationMessage('Something went wrong, Please try again later!!');
                setOpenNotify(true);
                setAlertType('error');
            });
        } catch (error) {
            console.error("Error performing bulk update:", error);
        }
    }

    return (
        <>
            {!userData || isLoading ?
                (<div className="row">
                    <div className="col-md-12 text-center p-4">
                        <CircularProgress />
                    </div>
                </div>) :
                (<div className="allProductsAndSales">
                    <Paper className={fixedHeightPaper}>
                        <Helmet>
                            <meta name="description" content="Find Order you have posted till now." />
                            <title>Order | Kaipsool Pharmatech</title>
                        </Helmet>
                        <div className="row d-flex justify-content-center align-items-center">
                            <div className="col-md-10 inline-row-style">
                                <h5>Today's Purchase List</h5>
                                <RefreshOrderFilter refreshData={fetchRecord} />
                            </div>
                            <div className="col-md-2">
                                <Button
                                    onClick={handleProceedNext}
                                    variant="contained"
                                    className="registerEmp__btnLogin jsmAdd floatRightt"
                                >
                                    {'Proceed Next'}
                                </Button>
                            </div>
                            {records.length > 0 ? <div className="row col-md-12 pickup-order-table">
                                <TblContainer>
                                    <TblHead />
                                    <TableBody>
                                        {
                                            records.map(item => (
                                                <TableRow key={item.id}>
                                                    <TableCell>
                                                        {item?.IsAvailable}
                                                        <Switch
                                                            checked={item?.IsAvailable}
                                                            onChange={() => handleToggle(item)}
                                                            color="primary"
                                                        />
                                                    </TableCell>
                                                    <TableCell>{item?.ProductName ? item.ProductName : "NA"}</TableCell>
                                                    <TableCell>{item?.ProductQuantity ? item.ProductQuantity : "NA"}</TableCell>
                                                    <TableCell>{item?.ProductScheme ? item.ProductScheme : "NA"}</TableCell>
                                                    <TableCell>{item?.MedicineType ? item.MedicineType : "Generic"}</TableCell>
                                                    <TableCell>
                                                        {typeof item?.SupplyOrderPostedDateTime == "string" ? item?.SupplyOrderPostedDateTime : parseDate(item?.SupplyOrderPostedDateTime)}
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        }
                                    </TableBody>
                                </TblContainer>
                                <TblPagination />
                            </div> : <div className="row col-md-12 mt-3 text-center">
                                <img src={NotFound} className="notFound" />
                                <h4>No Order Record Found!</h4>
                            </div>}
                        </div>
                    </Paper>
                </div>)
            }
            <WholesalerDialog
                isOpen={isPopupOpen} 
                onClose={() => setIsPopupOpen(false)}
                setSelectedWholesaler={setSelectedWholesaler}
                handleSubmit={handleSubmit}
            />
            <CustomAlert
                setOpenNotify={setOpenNotify}
                openNotify={openNotify}
                messageType={alertType}
                notificationMessage={notificationMessage}
            />
        </>
    )
}

export default SupplyPickupFlow
